import { createSlice } from "@reduxjs/toolkit"
import { useCallback, useEffect, useMemo, useState } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"

import { monitoringState, useMonitoredState, forHeartbeat } from "../utils"

const { initialState, actions } = monitoringState()
const reducers = { ...actions }

const slice = createSlice({
  name: 'owner_groups',
  initialState, reducers
})

export function useOwnerGroups(ids) {
  return useMonitoredState('owner_groups', slice.actions, ids)
}

export function useOwnerGroup(id) {
  const { owner_groups, allLoaded: loaded } = useOwnerGroups([id])
  return { owner_group: owner_groups[0], loaded }
}

export const heartbeatActions = forHeartbeat(slice.actions)
export default slice.reducer